import React, { MouseEvent } from 'react';
import cn from 'clsx';
import { KitchenCollection } from 'modules/collections';
import { createElementKey } from 'utils';
import { Link } from '../../../link';
import { HoverPriceMediaCardSwiper, PriceMediaCard } from '../../../price-media-card';
import { Typography } from '../../../typography';
import {
  catalogCardContent,
  catalogCardContentActiveImage,
  catalogCardContentImagePreview,
  catalogCardContentImagePreviewContainer,
  catalogCardContentImagePreviewContainerMobile,
  catalogCardContentImagePreviewRest,
  catalogCardContentImagePreviewWrapper,
  catalogLink,
  catalogFirstImage,
  catalogImage,
} from './catalog-card-styles';

type CatalogCardProps = {
  position: number;
  cardRefCb?: (el: HTMLAnchorElement | null) => void;
  collection: KitchenCollection | KitchenCollection[];
  onCardClick: (collection: KitchenCollection, position: number) => void;
  onCollectionPreviewClick?: (collection: KitchenCollection) => void;
  renderCardContent: (collection: KitchenCollection) => React.ReactNode;
}

const VISIBLE_PREVIEW_NUMBER = 3;

export const CatalogCard: React.FC<CatalogCardProps> = ({ position, cardRefCb, collection, onCardClick, onCollectionPreviewClick, renderCardContent }) => {
  const [activeCollection, setActiveCollection] = React.useState<KitchenCollection>(Array.isArray(collection) ? collection[0] : collection);

  const visiblePreview = Array.isArray(collection) ? collection.slice(0, VISIBLE_PREVIEW_NUMBER) : [];
  const restPreview = Array.isArray(collection) ? collection.slice(VISIBLE_PREVIEW_NUMBER) : [];

  const handleCardClick = (ckickedCollection: KitchenCollection, collectionPosition: number) => () => {
    onCardClick(ckickedCollection, collectionPosition);
  };

  const handleCardWheelClick = (ckickedCollection: KitchenCollection, collectionPosition: number) => (e: MouseEvent) => {
    if (e.button === 1) {
      handleCardClick(ckickedCollection, collectionPosition)();
    }
  };

  const handleCollectionPreviewClick = (clkickedCollection: KitchenCollection) => (e: MouseEvent) => {
    e.preventDefault();
    setActiveCollection(clkickedCollection);

    if (onCollectionPreviewClick) {
      onCollectionPreviewClick(clkickedCollection);
    }

    e.stopPropagation();
  }

  return (
    <Link
      className={catalogLink}
      onAuxClick={handleCardWheelClick(activeCollection, position)}
      onClick={handleCardClick(activeCollection, position)}
      href={activeCollection.productUrl}
      refCb={cardRefCb}
      title={activeCollection.displayedName}
    >
      <PriceMediaCard>
        <HoverPriceMediaCardSwiper
          keyName="gallery-catalog-simage"
          photosName={`Фото ${activeCollection.displayedName}`}
          photosSrc={activeCollection.mediaMainPhoto}
          imageClass={cn(catalogImage, { [catalogFirstImage]: position === 0 })}
        />
        <div className={catalogCardContent}>
          {renderCardContent(activeCollection)}
          {Array.isArray(collection) && (
            <div className={cn(
              catalogCardContentImagePreviewContainer,
              { [catalogCardContentImagePreviewContainerMobile]: restPreview.length > 0 }
            )}>
              {visiblePreview.map((card, index) => (
                <button
                  className={cn(
                    catalogCardContentImagePreviewWrapper,
                    { [catalogCardContentActiveImage]: card.productId === activeCollection.productId }
                  )}
                  key={createElementKey('catalog-preview', index)}
                  onClick={handleCollectionPreviewClick(card)}
                >
                  <img alt={card.displayedName} className={catalogCardContentImagePreview} src={card.mediaMainPhoto[0]} />
                </button>
              ))}

              {restPreview.length > 0 && (
                <button className={catalogCardContentImagePreviewRest}>
                  <Typography size="body_long" variant="m">+{restPreview.length}</Typography>
                </button>
              )}
            </div>
          )}
        </div>
      </PriceMediaCard>
    </Link>
  )
};
